import { useState, useEffect } from 'react';
import AdminLayout from "./AdminLayout";
import { IoCreateSharp } from "react-icons/io5";
import { connect } from 'react-redux';
import { addAdminEmail } from "../../../Firebase/actions/addAdminEmail";
import * as EmailValidator from 'email-validator';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles((theme) => ({
    select: {
        minWidth: '100%',
        fontSize: '1.2rem'
    },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const CreateAdmin = ({ addAdminEmail, resetSuccess, addAdminEmailSuccess, addAdminEmailError, resetError}) => {
    const classes = useStyles();
    const [ email, setEmail ] = useState('');
    const [adminLevel, setAdminLevel ] = useState('');
    const [ error, setError] = useState(null);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
      };
    
      const handleOpen = () => {
        setOpen(true);
      };


    const handleSubmit = (e) => {
        e.preventDefault();

        if(email !== '' || adminLevel !== '') {
            setError(null);

            if(!EmailValidator.validate(email)){
                setError('Please provide a valid email.');
            } else {
                document.getElementById('Btn').classList.add('is-loading');
                addAdminEmail(email, adminLevel);
                //console.log(email, adminLevel);
            }
        } else {
            setError('Please Enter an Email and Select an Admin Level.')
        }
    }

    useEffect(() => {
        if(addAdminEmailSuccess) {
            document.getElementById('Btn').classList.remove('is-loading');
            setEmail('');
            setAdminLevel('');

            // setFeedbackText('Admin Successfully Added.');
            // setSeverity('success');
            // setOpenFeedback(true);
            toast.success('Admin Successfully Added');

            resetSuccess();
            //console.log('run')
        }

        if(addAdminEmailError) {
            document.getElementById('Btn').classList.remove('is-loading');
           
            // setFeedbackText(addAdminEmailError);
            // setSeverity('error');
            // setOpenFeedback(true);

            toast.error(addAdminEmailError);
            resetError();

        }
    }, [addAdminEmailSuccess, resetSuccess, addAdminEmailError, resetError]);
       

    return ( 
        <AdminLayout>
            <ToastContainer />
            <div className="row pt-5">
                <div className="col s12 m10 l10 offfset-m1 offset-l1">
                    <h5 className="title has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Add Admin Email</h5>
                    <div className="divider mb-5"></div>

                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="input-field col s12 m6 l5">
                                <input id="email" type="email" onChange={(e) => setEmail(e.target.value)} value={email} required />
                                <label htmlFor="email" className="active">Email</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s12 m4">
                                <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Admin Level: </h5>
                                <InputLabel id="adminLevel">Select</InputLabel>
                                <Select
                                    className={classes.select}
                                    labelId="adminLevel"
                                    id="demo-controlled-open-select"
                                    open={open}
                                    onClose={handleClose}
                                    onOpen={handleOpen}
                                    onChange={(e) => setAdminLevel(e.target.value)} 
                                    value={adminLevel}
                                >
                                    <MenuItem value="Main">Main</MenuItem>
                                    <MenuItem value="Bursary">Bursary</MenuItem>
                                    <MenuItem value="Teacher">Teacher</MenuItem>
                                 </Select>
                            </div>
                        </div>
                        {
                            error && <p className="red-text text-darken-3">{error}</p>
                        }
                        <div className="control">
                            <button className="button is-success mt-5" id="Btn">
                                <span className="icon">
                                    <IoCreateSharp color="white"/>
                                </span>
                                <span className="white-text">Admin Added To Database</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </AdminLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addAdminEmailSuccess: state.addAdminEmail.addAdminEmailSuccess,
        addAdminEmailError: state.addAdminEmail.addAdminEmailError  
    }
    
}

const mapDispatchToProps = (dispatch) => {
    return {
        addAdminEmail: (email, adminLevel) => dispatch(addAdminEmail(email, adminLevel)),
        resetSuccess: () => dispatch({ type: "ADD_ADMIN_EMAIL", success: false }),
        resetError: () => dispatch({ type: "ADD_ADMIN_EMAIL_ERROR", success: false })
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(CreateAdmin);